import { Sparkles } from "lucide-react";
import { Badge } from "@/shared/ui/badge.jsx";
import { AppShell } from "@/shared/layouts/AppShell.jsx";

/**
 * Módulo reservado para as próximas etapas — mesmo texto e mesmo visual do
 * app atual.
 */
export function ComingSoon({ module, description }) {
  return (
    <div className="flex min-h-[70vh] items-center justify-center p-8">
      <div className="max-w-lg text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-primary/15 to-chart-2/15 ring-1 ring-primary/20">
          <Sparkles className="h-7 w-7 text-primary" />
        </div>
        <Badge variant="outline" className="mb-3">
          Etapa 2
        </Badge>
        <h2 className="font-display text-2xl font-semibold tracking-tight">{module}</h2>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{description}</p>
        <p className="mt-6 text-xs text-muted-foreground/70">
          Este módulo está reservado na arquitetura e será ativado nas próximas etapas do projeto.
        </p>
      </div>
    </div>
  );
}

/**
 * Fábrica das telas reservadas. Cada módulo pendente é uma linha de dado
 * em `PLACEHOLDER_MODULES`, não um arquivo de 12 linhas repetido onze
 * vezes como no app antigo.
 * @param {{ title: string, subtitle: string, description: string }} modulo
 */
export function makePlaceholderPage(modulo) {
  return function PlaceholderPage() {
    return (
      <AppShell title={modulo.title} subtitle={modulo.subtitle}>
        <ComingSoon module={modulo.title} description={modulo.description} />
      </AppShell>
    );
  };
}

/** Os 11 módulos que ainda não têm implementação — iguais aos de hoje. */
export const PLACEHOLDER_MODULES = [
  {
    path: "/pacientes",
    title: "Pacientes",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Cadastro completo de pacientes, histórico clínico, documentos e ficha unificada.",
  },
  {
    path: "/prontuario",
    title: "Prontuário",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Prontuário eletrônico com evolução clínica, anexos e assinatura digital.",
  },
  {
    path: "/orcamentos",
    title: "Orçamentos",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Montagem de orçamentos, planos de tratamento e acompanhamento de aprovação.",
  },
  {
    path: "/contratos",
    title: "Contratos",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Geração de contratos, assinatura eletrônica e arquivo por paciente.",
  },
  {
    path: "/financeiro",
    title: "Financeiro",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Contas a pagar e receber, fluxo de caixa e conciliação de recebimentos.",
  },
  {
    path: "/marketing",
    title: "Marketing",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Gestão de campanhas, origem de leads e retorno sobre investimento por canal.",
  },
  {
    path: "/ia",
    title: "Inteligência Artificial",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Atendimento assistido por IA, sugestões de resposta e análise preditiva do funil.",
  },
  {
    path: "/relatorios",
    title: "Relatórios",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Relatórios operacionais e comerciais com exportação em PDF e planilha.",
  },
  {
    path: "/bi",
    title: "Business Intelligence",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Painéis estratégicos com os principais indicadores da clínica.",
  },
  {
    path: "/multiunidades",
    title: "Multiunidades",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Gestão de várias unidades, times por filial e consolidação de resultados.",
  },
  {
    path: "/arquivos",
    title: "Central de Arquivos",
    subtitle: "Módulo reservado para próximas etapas",
    description: "Repositório de documentos, exames e imagens organizados por paciente.",
  },
];
